import { ModelIndexes } from "../../types/addContent";
import { useSharePricePerformanceStore } from "../../state/sharePricePerformanceStore";

export const applyOldModelState = (index: number, dataModel: any) => {
  const {
    setCompany,
    setTimePeriod,
    setAPALCompany,
    setSummaryTable,
    setCallOutBoxTable,
    setShadingPeriodTable,
    setVerticalLineTable,
  } = useSharePricePerformanceStore.getState();

  if (!dataModel) return;

  switch (index) {
    case ModelIndexes.TABLE_MODEL_INDEX:
      setCompany(dataModel.companies);
      setTimePeriod(dataModel.timePeriod);
      break;
    case ModelIndexes.CUSTOM_BUILD_INDEX:
      setAPALCompany([dataModel?.index?.defineIndexContituents]);
      break;
    case ModelIndexes.SUMMARY_TABLE:
      setSummaryTable(dataModel?.summaryPeriodTable);
      break;
    case ModelIndexes.CALL_OUT_BOXES:
      setCallOutBoxTable(dataModel?.callOutBoxesTable);
      break;
    case ModelIndexes.BACKGROUND_SHADING_TABLE_PANEL:
      setShadingPeriodTable(dataModel?.shadingPeriodTable);
      break;
    case ModelIndexes.VERTICAL_LINE_TABLE_PANEL:
      setVerticalLineTable(dataModel?.verticalLineTable);
      break;
    default:
      break;
  }
};
